import React from 'react';

const ManageAccounts = () => {
  return <div>No Account Available</div>;
};

export default ManageAccounts;
